document.addEventListener('DOMContentLoaded', function (event) {
    let button = document.querySelectorAll('[data-show-description]'),
        content = document.querySelectorAll('[data-description]');

    button.forEach(function (el) {
        el.addEventListener('click', function(e) {
            this.classList.toggle('is-active');
            this.parentElement.nextElementSibling.nextElementSibling.classList.toggle('is-active');
        });
    });
});